import type { ApiResult } from '@/infra/api'
import { API_ENDPOINTS, httpGet } from '@/infra/api'
import type {
  HostStatusesResponse,
  LatestSessionEventsResponse,
  SessionStatusesResponse,
} from './types'

export const hydrationClient = {
  fetchLatestSessionEvents(): Promise<ApiResult<LatestSessionEventsResponse>> {
    return httpGet<LatestSessionEventsResponse>(API_ENDPOINTS.SESSIONS_LATEST)
  },

  fetchSessionStatuses(): Promise<ApiResult<SessionStatusesResponse>> {
    return httpGet<SessionStatusesResponse>(API_ENDPOINTS.SESSION_STATUSES)
  },

  fetchHostStatuses(): Promise<ApiResult<HostStatusesResponse>> {
    return httpGet<HostStatusesResponse>(API_ENDPOINTS.HOST_STATUSES)
  },
}
